/* eslint-disable consistent-return */
/* eslint-disable multiline-ternary */
/* eslint-disable react/no-danger */
import React from 'react'
import { convertToSlug } from 'src/utils/IdGenerator'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import styles from './onecolumnwidth.module.scss'
// @ts-expect-error
const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

const getModifiedHtml = tableContent => {
  if (tableContent) {
    const $ = cheerio.load(tableContent, null, false)
    $('img').attr('loading', 'lazy')
    $('img').attr('decoding', 'async')

    $('img').each((_, img) => {
      $(img).attr('width', '100') // Placeholder width
      $(img).attr('height', '100') // Placeholder height
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    return modifiedHTML
  }
}

const separateImgFromHTML = originalHTML => {
  const $ = cheerio.load(originalHTML, null, false)

  // Modify images
  $('img').attr('loading', 'lazy')
  $('img').attr('decoding', 'async')
  $('img').each((_, img) => {
    $(img).attr('width', '100') // Placeholder width
    $(img).attr('height', '100') // Placeholder height
  })

  const imgTags = $('img')

  if (imgTags.length >= 2) {
    const desktopImg = imgTags.eq(0)
    const mobileImg = imgTags.eq(1)

    const desktopContent = `<p>${desktopImg}</p>`
    const mobileContent = `<p>${mobileImg}</p>`

    return { desktopContent, mobileContent }
  }
}

const OneColumnWidth = ({ data }) => {
  const content =
    data?.data?.attributes?.variant === 'justImageLikeBanner'
      ? separateImgFromHTML(data?.data?.attributes?.content)
      : getModifiedHtml(data?.data?.attributes?.content)

  // Extract the h2 content and headerTabName
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = data?.data?.attributes.content.match(h2Regex)
  const h2Content = matches ? matches[1] : null
  const idContent = data?.data?.attributes.headerTabName || h2Content
  const isWhiteBg = !['ContentWithPurpleBackGround', 'ContentWithParaImageAndButton'].includes(
    data?.data?.attributes?.variant
  )

  return data?.data?.attributes?.variant === 'justImageLikeBanner' ? (
    <ErrorBoundary data={data}>
      <div className={`${styles.justImageLikeBanner} ${isWhiteBg && 'white'}`} id={convertToSlug(idContent)}>
        <div className={styles.desktopContent} dangerouslySetInnerHTML={{ __html: content?.desktopContent }} />
        <div className={styles.mobileContent} dangerouslySetInnerHTML={{ __html: content?.mobileContent }} />
      </div>
    </ErrorBoundary>
  ) : (
    <ErrorBoundary data={data}>
      <div className={`${styles.mainContainer} ${isWhiteBg && 'white'}`} id={convertToSlug(idContent)}>
        <div className={`${styles[data?.data?.attributes?.variant]}`} dangerouslySetInnerHTML={{ __html: content }} />
        {data?.data?.attributes?.variant === 'ContentWithPurpleBackGround' && (
          <div className={styles.colorBlendParent}>
            <div className={styles.colorBlendTopRightCircle} />
            <div className={styles.colorBlendBottomLeftCircle} />
          </div>
        )}
      </div>
    </ErrorBoundary>
  )
}

export default OneColumnWidth
